import { CREDENTIALS, UPDATE_AUTH, UPDATE_CUSTOMER_ID } from '../types/user';

export function storeUserData(payload: any) {
  return {
    type: CREDENTIALS,
    payload,
  };
}

export function updateAuth(payload: any) {
  return {
    type: UPDATE_AUTH,
    payload,
  };
}

export function updateCustomerId(payload: any) {
  return {
    type: UPDATE_CUSTOMER_ID,
    payload,
  };
}
